import { render } from "./VideoList.vue?vue&type=template&id=cc929ef2&scoped=true"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"

import "./VideoList.vue?vue&type=style&index=0&id=cc929ef2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc929ef2"]])

export default __exports__